import React from 'react';
import { Tag, Tooltip } from 'tea-component';

import type {
  ISelectOptionWithGroup,
  ICommonFlagMap,
  IGenreRes,
  IGenreMetadata,
} from '@intelligence/types/common';

export const generateGenreStr = (genres: string[]): string => {
  if (!Array.isArray(genres)) return '';
  return genres.join('|');
};

export const analysisGenreStr = (genreStr: string): string[] => {
  if (typeof genreStr !== 'string') return [];
  return genreStr.split('|').filter((item) => item?.length);
};

export const analysisMainGenresAndSubGenres = (isIegg: boolean, genresRes: IGenreRes): {
  mainGenres: IGenreMetadata[];
  subGenres: IGenreMetadata[];
} => {
  const mainGenres = isIegg ? genresRes?.ieg : genresRes?.annir;
  if (!Array.isArray(mainGenres)) return {
    mainGenres: [],
    subGenres: [],
  };
  // 主品类options数据
  const mains: IGenreMetadata[] = [];
  // 主品类map（用于去重）
  const mainsMap: ICommonFlagMap = {};

  // 副品类options数据
  const subs: IGenreMetadata[] = [];
  // 副品类map（用于去重）
  const subsMap: ICommonFlagMap = {};

  for (const mainGenre of mainGenres) {
    /**
     * 组装主品类options数据
     */
    const mainGenreCode = mainGenre?.main_genre?.genre;
    if (mainGenreCode && !mainsMap[mainGenreCode]) {
      mains.push(mainGenre?.main_genre);
      mainsMap[mainGenreCode] = true;
    }

    /**
     * 组装副品类options数据
     */
    const subGenres = mainGenre?.sub_genre;
    if (Array.isArray(subGenres)) {
      for (const subGenre of subGenres) {
        const subGenreCode = subGenre?.genre;
        if (subGenreCode && !subsMap[subGenreCode]) {
          subs.push(subGenre);
          subsMap[subGenreCode] = true;
        }
      }
    }
  }

  return {
    mainGenres: mains,
    subGenres: subs,
  };
};

const getOptionText = (option: ISelectOptionWithGroup): string => option?.label || option?.value;

export const renderButton = (onDelete: (payload: string) => void, formatMessage: Function) => {
  return (options: ISelectOptionWithGroup[]) => {
    if (!Array.isArray(options) || !options.length) return (
      <div className="dbi-genre-feedback-change">{formatMessage({ id: 'dbi_please_select' })}</div>
    );

    return (
      <Tooltip title={options.map(getOptionText)?.join(', ')}>
        <div className="dbi-genre-feedback-box">
          <Tag.Group>
            {options.map((option) => {
              const optionValue = option?.value;
              return (
                <Tag
                  key={optionValue}
                  onClose={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    onDelete(optionValue);
                  }}
                >
                  {getOptionText(option)}
                </Tag>
              );
            })}
          </Tag.Group>
        </div>
      </Tooltip>
    );
  };
};
